import styled from "styled-components";

const NavText = styled.div`
  cursor: pointer;
  text-decoration: none;
  color: darkgrey;

  &:hover {
    color: black;
  }
`;

export default NavText;
